import { Component, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { NavbarComponent } from "./navbar/navbar.component";
import { FooterComponent } from "./footer/footer.component";
import { ToastModule } from "primeng/toast";
import { UserService } from "./service/user.service";
import { ELocalStorage } from "./enums/ELocalStorage";

@Component({
    selector: 'app-root',
    standalone: true,
    imports: [RouterOutlet, NavbarComponent, FooterComponent, ToastModule],
    templateUrl: './app.component.html',
    styleUrl: './app.component.scss'
})

export class AppComponent implements OnInit {
    constructor(private userService: UserService) {
    }

    async ngOnInit() {
        let defaultAMToken: any = await this.userService.getAMToken();
        window.localStorage.setItem(ELocalStorage.DEFAULT_AM_AUTH, defaultAMToken.token);
    }
}

